import { Color } from '@ardoq/color-helpers';
import styled from 'styled-components';
import { IconProps, IconSize } from '../types';

/**
 * Inlined SVG version of the ardoq logo loader animated icon.
 *
 * This is necessary for the animation to work under Safari, as Safari does not support
 * animating elements referenced by <use> elements.
 */
export const ArdoqLogoLoaderIcon = (props: Omit<IconProps, 'iconName'>) => (
  <ArdoqLogoLoaderSvgStyle
    color={props.color}
    size={props.iconSize ?? IconSize.MEDIUM}
    viewBox="0 0 48 48"
  >
    <rect
      className="ardoq_logo_loader__expanding"
      x="0"
      y="0"
      height="16"
      width="16"
      fill="currentColor"
    />
    <rect
      className="ardoq_logo_loader__compressing"
      x="0"
      y="32"
      height="16"
      width="48"
      fill="currentColor"
    />
  </ArdoqLogoLoaderSvgStyle>
);

const ArdoqLogoLoaderSvgStyle = styled.svg<{ color?: Color; size: number }>`
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  color: ${props => props.color};

  .ardoq_logo_loader__expanding {
    animation: ardoq_logo_loader__expandx 2s ease-in-out infinite;
  }
  @keyframes ardoq_logo_loader__expandx {
    0% {
      transform: scaleX(1);
    }
    50% {
      transform: scaleX(3.076923076923077);
    }
    100% {
      transform: scaleX(1);
    }
  }
  .ardoq_logo_loader__compressing {
    animation: ardoq_logo_loader__compressx 2s ease-in-out infinite;
  }
  @keyframes ardoq_logo_loader__compressx {
    0% {
      transform: scaleX(1);
    }
    50% {
      transform: scaleX(0.325);
    }
    100% {
      transform: scaleX(1);
    }
  }
`;
